import DnsIcon from '@material-ui/icons/Dns';
import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

export const pm2Module = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'pm2',
      params: {
        path: '/pm2',
        title: 'System',
        icon: <DnsIcon />,
        loader: async () => import('./Pm2Page').then(m => <m.Pm2Page />),
      },
    }),
  ],
});
